import { render, staticRenderFns } from "./ProfilePlugin.vue?vue&type=template&id=895fb7bc&scoped=true&"
import script from "./ProfilePlugin.vue?vue&type=script&lang=js&"
export * from "./ProfilePlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895fb7bc",
  null
  
)

export default component.exports